import clsx from "clsx";
import dialogStyles from "./dialogStyles.module.css";
import SplitterLocal from "../../../Tools/Splitter";
import React, { useEffect, useRef } from "react";

interface Props {
  showLeft?: boolean;
  showRight?: boolean;
  showBottom?: boolean;
  leftContent?: React.JSX.Element;
  rightContent?: React.JSX.Element;
  bottomContent?: React.JSX.Element;
  mainContent: React.JSX.Element;
  propsLeft?: any;
  propsRight?: any;
  propsBottom?: any;
  propsMain?: any;
  collapsedLeft?: boolean;
  collapsedRight?: boolean;
  collapsedBottom?: boolean;
  updateLeft?: () => void | Promise<void>;
  updateRight?: () => void | Promise<void>;
  updateBottom?: () => void | Promise<void>;
  updateMain?: () => void | Promise<void>;
  onCollapseLeft?: () => void | Promise<void>;
  onCollapseRight?: () => void | Promise<void>;
  onCollapseBottom?: () => void | Promise<void>;
  onResizeEndLeft?: () => void | Promise<void>;
  onResizeEndRight?: () => void | Promise<void>;
  onResizeEndBottom?: () => void | Promise<void>;
}

export default function DialogMultiSplitContent(props: Props) {
  const transitionDuration = 250;

  const {
    showLeft,
    showRight,
    showBottom,
    leftContent,
    rightContent,
    bottomContent,
    mainContent,
    propsLeft,
    propsRight,
    propsBottom,
    propsMain,
    collapsedLeft,
    collapsedRight,
    collapsedBottom,
    updateLeft,
    updateRight,
    updateBottom,
    updateMain,
    onCollapseLeft,
    onCollapseRight,
    onCollapseBottom,
    onResizeEndLeft,
    onResizeEndRight,
    onResizeEndBottom,
  } = props;

  useEffect(() => {
    !collapsedLeft && updateLeft && updateLeft();
  }, [propsLeft]);
  useEffect(() => {
    !collapsedRight && updateRight && updateRight();
  }, [propsRight]);
  useEffect(() => {
    !collapsedBottom && updateBottom && updateBottom();
  }, [propsBottom]);
  useEffect(() => {
    updateMain && updateMain();
  }, [propsMain]);

  useEffect(() => {
    onCollapseLeft &&
      setTimeout(() => {
        onCollapseLeft();
      }, transitionDuration);
  }, [collapsedLeft]);
  useEffect(() => {
    onCollapseRight &&
      setTimeout(() => {
        onCollapseRight();
      }, transitionDuration);
  }, [collapsedRight]);
  useEffect(() => {
    onCollapseBottom &&
      setTimeout(() => {
        onCollapseBottom();
      }, transitionDuration);
  }, [collapsedBottom]);

  return (
    <div className={clsx(dialogStyles.fullDialogFlexContainer, dialogStyles.dialogMainBlockSideBorder)}>
      <SplitterLocal
        style={{ width: "100%", height: "100%" }}
        primaryIndex={0}
        transitionDuration={transitionDuration}
        sizeSecondary={"20%"}
        hideButtons={true}
        onResizeEnd={onResizeEndRight}
        collapsed={collapsedRight}
        orientation="vertical"
      >
        <div className={clsx(dialogStyles.fullDialogSpaceContainer, dialogStyles.flexContainer)}>
          <SplitterLocal
            style={{ width: "100%", height: "100%" }}
            primaryIndex={1}
            transitionDuration={transitionDuration}
            sizeSecondary={"20%"}
            hideButtons={true}
            onResizeEnd={onResizeEndLeft}
            collapsed={collapsedLeft}
            orientation="vertical"
          >
            {showLeft && (
              <div className={clsx(dialogStyles.fullDialogSpaceContainer, dialogStyles.flexContainer)}>
                {leftContent}
              </div>
            )}
            <div className={clsx(dialogStyles.fullDialogSpaceContainer, dialogStyles.flexContainer)}>
              <SplitterLocal
                style={{ width: "100%", height: "100%" }}
                primaryIndex={0}
                transitionDuration={transitionDuration}
                sizeSecondary={"30%"}
                hideButtons={true}
                onResizeEnd={onResizeEndBottom}
                collapsed={collapsedBottom}
                orientation="horizontal"
              >
                <div className={clsx(dialogStyles.fullDialogSpaceContainer)}>{mainContent}</div>
                {showBottom && (
                  <div className={clsx(dialogStyles.fullDialogSpaceContainer, dialogStyles.flexContainer)}>
                    {bottomContent}
                  </div>
                )}
              </SplitterLocal>
            </div>
          </SplitterLocal>
        </div>
        {showRight && (
          <div className={clsx(dialogStyles.fullDialogSpaceContainer, dialogStyles.flexContainer)}>{rightContent}</div>
        )}
      </SplitterLocal>
    </div>
  );
}
